import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../logo-quadrato.png";

export default function MarketingFooter() {
  const navigate = useNavigate();

  return (
    <footer className="hp-footer">
      <img src={logo} alt="QrMenu-Italia" className="hp-footer-logo" />

      <div>
        <p className="hp-footer-copy">
          © {new Date().getFullYear()} QrMenu-Italia · Progetto QrZone
        </p>

        <p
          className="hp-footer-copy"
          style={{ marginTop: "6px", fontSize: "12px" }}
        >
          <span
            onClick={() => navigate("/privacy-policy")}
            style={{ cursor: "pointer" }}
          >
            Privacy Policy
          </span>

          {" · "}

          <span
            onClick={() => navigate("/cookie-policy")}
            style={{ cursor: "pointer" }}
          >
            Cookie Policy
          </span>
        </p>
      </div>
    </footer>
  );
}